<template>
  <div v-if="!data.delete" class="grid grid--middle">
    <div
      class=" grid__cell col1-of-12--small col1-of-12--medium col1-of-12--large-up ta-center"
    >
      <button
        v-if="!first"
        @click="move(-1)"
        type="button"
        class="fw-bold fs-sm fc-violet"
        tabindex="-1"
      >
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button
        v-if="!last"
        @click="move(1)"
        type="button"
        class="fw-bold fs-sm fc-violet"
        tabindex="-1"
      >
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div
      class="grid__cell col9-of-12--small col6-of-12--medium col7-of-12--large-up"
    >
      <label class="mb-xs">
        <input
          data-hj-allow
          @change="update($event, 'name')"
          type="text"
          :value="data.name"
        />
      </label>
    </div>
    <div
      class="grid__cell col2-of-12--small col5-of-12--medium col4-of-12--large-up"
      style="padding-left: 0.75rem;"
    >
      <button
        @click="remove"
        type="button"
        class="fw-bold fs-sm fc-alert"
        tabindex="-1"
      >
        <i
          class="fa fa-times-circle"
          aria-hidden="true"
          style="font-size: 18px;"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
import { reorderUpdateDeleteChild } from '@/utils/mixins';

export default {
  mixins: [reorderUpdateDeleteChild],
  name: 'FilterChild',
  methods: {
    move(direction) {
      this.$emit('change-order', {
        direction,
        optionIndex: this.data.order,
      });
    },
    remove() {
      if (this.new) {
        this.$emit('remove-new-item');
      } else {
        this.$emit('remove-item');
      }

      if (!this.newItem) this.showing = false;
    },
    update(e, key) {
      this.$emit(
        'item-change',
        { value: e.target.value, key, optionIndex: this.data.order },
        this.new
      );
    },
  },
};
</script>
